export default __webpack_public_path__ + "static/media/Play_Paper.7a59bae1.png";